import "./app.js";
import "../scss/singular.scss";

import commentLike from "./js-modules/comment-like";
import { commentToggle } from "./js-modules/comment-toggle";
import initAjaxComment from "./js-modules/init-ajax-comment";
import shareFbMessenger from "./js-modules/share-fb-messenger";
import postLike from "./js-modules/post-like";
import promoClose from "./js-modules/promo-close";
import replyComment from "./js-modules/reply-comment";
import sharePostBtn from "./js-modules/share";
import lightview from "./js-modules/lightview";
import gutenbergAds from "./js-modules/gutenberg-ads";

window.addEventListener("DOMContentLoaded", function () {
	// single
	shareFbMessenger();
	replyComment();
	commentLike();
	postLike();
	promoClose();
	initAjaxComment();
	sharePostBtn();
	lightview();
	gutenbergAds();

	//same height playlist and video
	const sameHeightVideoPlaylist = () => {
		let document_width = window.innerWidth;
		const playlist = document.querySelector(".playlist");
		if (playlist !== null) {
			if (document_width > 991) {
				const video = document.querySelector(".hero-video-playlist .ratio");
				if (video) {
					const videoHeight = video.offsetHeight;
					playlist.style.height = videoHeight + "px";
				}
			} else {
				playlist.style.height = "auto";
			}
		}
	};

	sameHeightVideoPlaylist();

	window.addEventListener("resize", function () {
		sameHeightVideoPlaylist();
	});

	let openCommentPanel = new commentToggle(".comment-toggle-js");
	openCommentPanel.init();
});
